import React from "react";
import {TextDescriptionView, TypeTitle, NameTitle} from "./Products";
import Color from "../assets/Colors";
import {ButtonLink} from "./Button";
import {useLocation} from "react-router-dom";
import {isMobile, reverseDate} from "../constants/Helpers";
import {TitleViewCard} from "./HeadView";
import parse from "html-react-parser";
import {IconTypeCourse} from "../components/IconType";

export default function HeadsVies({description, subtitle, icon, title, courseName, type}) {
   return (
      <>
         <IconTypeCourse type={type} />
         <div className="titles">
            <TitleViewCard className="principalTitle" color={Color.primary}>
               {title}
            </TitleViewCard>
            <TextDescriptionView className="viewDescription">{subtitle}</TextDescriptionView>
         </div>
         <div className="desc">
            <TextDescriptionView className="viewDescription">{parse(description)}</TextDescriptionView>
         </div>
      </>
   );
}
HeadsVies.defaultProps = {
   description: "texto ",
};

export function HeadSuscribe({data}) {
   let location = useLocation();
   // location.pathname
   // console.log(data);
   const {icon, endDate, startDate, longDescription, courseName, courseType, idCourseType} = data;
   return (
      <>
         <IconTypeCourse type={idCourseType} classname="icon" />
         {/* <img src={icon} className="icon" alt="icon" /> */}
         <div className="titles">
            <TitleViewCard>{courseType}</TitleViewCard>
            <NameTitle color={Color.primary} weight="500">
               {courseName}
            </NameTitle>
            <div className="itemInfoHead itemBtnContainer">
               <ButtonLink to={`${location.pathname}?modal=true`} className="btnModal">
                  inscribirme
               </ButtonLink>
            </div>
         </div>
         <div className="desc">
            <div className="infoHead">
               {isMobile ? (
                  <>
                     <div className="itemInfoHead">
                        <img src={require("../assets/icons/clock.png")} alt="clock" className="deatailInfoIcon" />
                        <div>
                           <TypeTitle size="1.5em">Duración:</TypeTitle>
                           <NameTitle color={Color.primary} size="1.5em" weight="bold">
                              {endDate} horas
                           </NameTitle>
                        </div>
                     </div>
                     <div className="itemInfoHead">
                        <img src={require("../assets/icons/calendar.png")} alt="calendar" className="deatailInfoIcon" />
                        <div>
                           <TypeTitle size="1.5em">Inicio de curso:</TypeTitle>
                           <NameTitle color={Color.primary} size="1.5em" weight="bold">
                              {reverseDate(startDate)}
                           </NameTitle>
                        </div>
                     </div>
                  </>
               ) : (
                  <>
                     <div className="itemInfoHead">
                        <img src={require("../assets/icons/clock.png")} alt="clock" className="deatailInfoIcon" />
                        <TypeTitle size="1.5em">Duración:</TypeTitle>
                        <NameTitle color={Color.primary} size="1.5em" weight="bold">
                           {endDate} horas
                        </NameTitle>
                     </div>
                     <div className="itemInfoHead">
                        <img src={require("../assets/icons/calendar.png")} alt="calendar" className="deatailInfoIcon" />
                        <TypeTitle size="1.5em">Inicio de curso:</TypeTitle>
                        <NameTitle color={Color.primary} size="1.5em" weight="bold">
                           {reverseDate(startDate)}
                        </NameTitle>
                     </div>
                  </>
               )}
            </div>
            <TextDescriptionView className="viewDescription">{parse(longDescription)}</TextDescriptionView>
         </div>
      </>
   );
}

HeadSuscribe.defaultProps = {
   longDescription: "texto",
   list: [],
};
